module.exports = __webpack_public_path__ + "img/theme-1.ade8c62e.png";